import { api } from '../api';

const CANVA_BASE_URL = process.env.REACT_APP_CANVA_BASE_URL;
const CONVERSATION_BASE_URL = process.env.REACT_APP_CONVERSATION_BASE_URL;
const FLOW_BASE_URL = process.env.REACT_APP_FLOW_BASE_URL;

export const extendedApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPurchaseNumberByEmail: builder.query({
      query: (email) => ({
        url: `${CONVERSATION_BASE_URL}/api/Public_api/getPurchaseNumber`,
        method: 'GET',
        params: { email },
      }),
      transformResponse: (resp) => resp,
    }),
    getLanderProjects: builder.query({
      query: (email) => ({
        url: `${CANVA_BASE_URL}/publicapi/getDeployedLinks`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: { email },
      }),
      transformResponse: (resp) => resp,
    }),
    getWhatsAppNumbers: builder.query({
      query: (email) => ({
        url: `${FLOW_BASE_URL}/api/phone-numbers/${email}`,
        method: 'GET',
      }),
      transformResponse: (resp) => resp,
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetPurchaseNumberByEmailQuery,
  useGetLanderProjectsQuery,
  useGetWhatsAppNumbersQuery,
} = extendedApi;
